import {
  Chip,
  makeStyles,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setTimecardId } from '../../redux/general';
import { createTimecard, getTimecard } from '../../redux/timecard';
import dateUtil from '../../util/dateUtil';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
  },
  header: {
    marginRight: '10px',
  },
}));

const mapStateToProps = (state) => ({
  timecards: state.user.timecards,
  timecard: state.timecard,
});

const TimecardSelector = ({ timecard, timecards }) => {
  const classes = useStyles();
  const [options, setOptions] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    const tempOptions = timecards.map((tc) => {
      const startDate = dateUtil.stringToShortDateFormat(tc.startDate);
      const endDate = dateUtil.stringToShortDateFormat(tc.endDate);
      return {
        label: startDate + ' - ' + endDate + ' (card #' + tc.timecardId + ')',
        value: tc.timecardId,
        status: tc.status,
      };
    });
    setOptions(tempOptions);
  }, [timecards]);

  if (!options) return '';
  const onChange = (event) => {
    if (event.target.value > 0) {
      //Existing timecard selected
      dispatch(getTimecard(event.target.value));
    } else {
      dispatch(createTimecard());
    }
  };
  return (
    <div className={classes.wrapper}>
      <Typography style={{ marginTop: 3 }} variant="h6">
        Pay Period:
      </Typography>
      <TextField
        select
        value={timecard.timecardId}
        onChange={onChange}
        InputProps={{ disableUnderline: true }}
      >
        <MenuItem value={-1}>Create Next Timecard</MenuItem>
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label} <Chip label={option.status} />
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};

export default connect(mapStateToProps)(TimecardSelector);
